const errorLogger = (error: Error, info: { componentStack: string }) => {
    console.error("Error :", error)
    console.error("info :", info)
}

export { errorLogger }
